import React from 'react'
import { ChatResponse } from "../components/message-components/chat-response.component";
import { globalConstants } from "../constants/globalConstants";
import UtilService from "../services/util.service";
import ChatBotApiService from '../services/chatbot-api.service';
import GlobalStoreService from "../services/global-store.service";
import ChatActionType from '../enums/action-types/ChatActionType';
import ActionsCommonService from './actions-common.service';
import ChatHistoryService from "../services/chatHistory.service";
import PlatformType from '../enums/PlatformType';
import TrackingMiddlewareService from './tracking-middleware.service';
import TemplateName from '../enums/templateName'
import ComponentTypes from '../enums/ComponentTypes'
import TrackingKey from '../enums/trackingKey'
import { static_links } from '../constants/static_links';
import ActionHandlerService2 from '../services/actions-handler.service2'

import { SCRIPTS } from "../constants/staticScripts";
import ScenarioType from '../enums/scenario-type';


export default class ActionHandlerService {

    static handleCreateSr = (params) => {
        ActionsCommonService.handleCreateSr(params);
    }

    static stripIfJsonFromDescription(description) {
        if (description && description.indexOf("[json]") > -1 && description.split("[json]").length === 3) {
            description.replace("[json]" + description.split("[json]")[1] + "[json]", "");
        }
    }

    static handleLinkAsChoiceWithinScenario = (data, resolve, reject) => {
        const linkData = ActionHandlerService.getLinkDataForChoice(data.user_response, data.scenarioResponse);
        if (linkData) {
            const platformType = GlobalStoreService.get("platformType");
            switch (platformType) {
                case PlatformType.WEB:
                    let webLink = linkData["webAppLink"];
                    if (webLink) {
                        webLink = ActionHandlerService.getDynamicLinkUrl(webLink, data.scenarioResponse);
                        window.open(webLink);
                    }
                    break;
                case PlatformType.ANDROID:
                    let androidLink = linkData["androidAppLink"];
                    if (androidLink) {
                        androidLink = ActionHandlerService.getDynamicLinkUrl(androidLink, data.scenarioResponse);
                        window.open(androidLink);
                    }
                    break;
                case PlatformType.IOS:
                    let iosLink = linkData["iosAppLink"];
                    if (iosLink) {
                        iosLink = ActionHandlerService.getDynamicLinkUrl(iosLink, data.scenarioResponse);
                        window.open(iosLink);
                    }
                    break;
            }
        }
        // So that we treat a link as the last step
        data.scenarioResponse["scenarioActive"] = false;
        resolve(resolve({ scenarioResponse: data.scenarioResponse }));
    };

    static getDynamicLinkUrl = (linkUrl, scenarioResponse) => {
        const currentNumber = GlobalStoreService.get("currentNumber") ? GlobalStoreService.get("currentNumber") : "";
        linkUrl = UtilService.replaceAll(linkUrl, "{mobile}", currentNumber);
        const templateNameList = scenarioResponse.templateNameList;
        if (templateNameList) {
            switch (true) {
                case templateNameList.indexOf("Outstanding_Amount") > -1:
                case templateNameList.indexOf("PAY_MY_BILL") > -1:
                    const outstandingAmountResponse = ActionHandlerService.getTemplateResponseObject(scenarioResponse.response);
                    try {
                        const outstandingAmount = JSON.parse(outstandingAmountResponse["template_res_string"]);
                        linkUrl = UtilService.replaceAll(linkUrl, "{amount}", outstandingAmount["Outstanding Amount"]);
                        //remove source and uri params from url if exists in case of old app context

                        if (window.MyAirtelAppReact) {
                            linkUrl = UtilService.removeSourceAndUriParamsFromLink(linkUrl)

                        }

                    } catch (e) { }
                    break;
            }
        }

        return linkUrl;
    }

    static handleBookmarkOptionWithinScenario = (bookmarkedData, resolve, reject, retry_count) => {
        // console.log(bookmarkedData)
        const bookmarkedScenario = {
            scenarioId: bookmarkedData.scenarioId,
            scenarioName: "",
            scenarioLob: bookmarkedData.lob ? bookmarkedData.lob : ""
        };
        bookmarkedData['isBookmarkedScenario'] = true;
        if (bookmarkedData.askForLogin) {
            if (GlobalStoreService.get("isUserLoggedIn")) {
                ActionHandlerService2.initiateScenario(
                    bookmarkedScenario,
                    resolve,
                    reject, retry_count
                );
            } else {

                ActionHandlerService.showLoginForm(bookmarkedData, resolve)

            }
        } else {
            ActionHandlerService2.initiateScenario(
                bookmarkedScenario,
                resolve,
                reject, retry_count
            );
        }
    };

    static getLinkDataForChoice = (enteredText, result) => {
        return ActionsCommonService.getLinkDataForChoice(enteredText, result);
    };

    static getBookmarkedScenarioIdForChoice = (enteredText, result) => {
        return ActionsCommonService.getBookmarkedScenarioIdForChoice(enteredText, result);
    };

    static chooseTemplateToShow = (template_list, response, showPopup, chatItem, handleOptionsClick) => {
        let response_json
        try {
            response_json = JSON.parse(response)
        }
        catch (e) {
            response_json = undefined
        }
        let message_obj

        if (!response_json || (typeof (response_json) === 'object' && Object.keys(response_json).length === 0)) {
            message_obj = {
                component_type: 'DEFAULT',
                message: SCRIPTS.NO_SYSTEM_INFO_MESSAGE,
                messageTime: UtilService.getCurrentTime()
            }
        }
        switch (template_list[0]) {
            case TemplateName.Data_Balance_Details:
                if (response_json) {
                    message_obj = {
                        component_type: ComponentTypes.DATA_BALANCE,
                        message: response,
                        messageTime: UtilService.getCurrentTime()
                    }
                }
                return { message_obj }
            case TemplateName.Outstanding_Amount:

                if (response_json) {
                    message_obj = {
                        component_type: ComponentTypes.OUTSTANDING,
                        message: response,
                        messageTime: UtilService.getCurrentTime()
                    }
                }
                return { message_obj }

            case TemplateName.CURRENT_BILL_PLAN:

                if (response_json) {
                    message_obj = {
                        component_type: ComponentTypes.CURRENT_BILL_PLAN,
                        message: response,
                        messageTime: UtilService.getCurrentTime()
                    }
                }
                return { message_obj }

            case TemplateName.Eligible_Bill_Plans:
            case TemplateName.New_Bill_Plan:
                if (response_json) {
                    message_obj = {
                        component_type: ComponentTypes.MONTHLY_PLAN,
                        message: response,
                        messageTime: UtilService.getCurrentTime(),
                        template_name: template_list[0]
                    }
                }
                return { message_obj, show_cancel_comp: true, cancel_obj: { type: template_list[0] }, options_hidden: true }

            case TemplateName.PAY_MY_BILL:
                return {};

            case TemplateName.PREV_DUPLICATE_BILLS:

                if (response_json) {
                    message_obj = {
                        component_type: ComponentTypes.PREV_DUPLICATE_BILLS,
                        message: response,
                        messageTime: UtilService.getCurrentTime()
                    }
                }
                return { message_obj, options_hidden: true }

            case TemplateName.PREV_PAYMENT_RECEIPTS:
                if (response_json) {
                    message_obj = {
                        component_type: ComponentTypes.PREV_PAYMENT_RECEIPTS,
                        message: response,
                        messageTime: UtilService.getCurrentTime()
                    }
                }
                return { message_obj, options_hidden: true }

            case TemplateName.IR_ACTIVATED_PACKS_DEACTIVATION:
            case TemplateName.IR_SERVICE_DEACTIVATION:
            case TemplateName.IR_MULTIPLE_ZONE_PACKS:
            case TemplateName.IR_SINGLE_ZONE_PACKS:

                if (response_json) {
                    message_obj = {
                        component_type: ComponentTypes.IR_PACK_DEACTIVATION,
                        message: response,
                        messageTime: UtilService.getCurrentTime(),
                        template_list,
                        chatItem
                    }
                }
                return { message_obj, show_cancel_comp: true, cancel_obj: { type: TemplateName.IR_ACTIVATED_PACKS_DEACTIVATION }, options_hidden: true }

            default:
                return undefined
        }

    }

    static getTemplateResponseFromSystemInfo = (systemInfo, templateNameList, result) => {
        let res
        switch (templateNameList[0]) {
            case TemplateName.PREV_DUPLICATE_BILLS: {
                systemInfo.map(info => {
                    if (info.tagName === "BOT - LAST 3 BILLS") {
                        info.information && info.information.length > 0 && info.information.map(end_info => {
                            if (end_info.tagName === "Last three bills") {
                                let res_obj = {
                                    transactionId: result.transactionId,
                                    authToken: result.authToken,
                                    bills_string: end_info.informationDisplayValue
                                }
                                res = JSON.stringify(res_obj)
                            }
                        })
                    }
                })
                return res
            }
            case TemplateName.New_Bill_Plan:
            case TemplateName.Eligible_Bill_Plans: {
                systemInfo.map(info => {
                    if (info.tagName === "BOT - ELIGIBLE BILL PLANS") {
                        info.information && info.information.length > 0 && info.information.map(end_info => {
                            if (end_info.tagName === "Eligible Bill Plans for Change") {
                                res = end_info.informationDisplayValue
                            }
                        })
                    }
                })
                return res
            }
            case TemplateName.Data_Balance_Details: {
                systemInfo.map(info => {
                    if (info.tagName === "COMPTEL - IN FAMILY QUOTA INFORMATION" || info.tagName === "COMPTEL - SIEBEL - IN Family Quota Info") {
                        info.information && info.information.length > 0 && info.information.map(end_info => {
                            res = JSON.stringify(info.information)
                        })
                    }
                })
                return res
            }
            case TemplateName.Outstanding_Amount: {
                systemInfo.map(info => {
                    if (info.tagName === "FX - CUSTOMER BILL DETAILS" || info.tagName === "SIEBEL - Cust Account Summary") {
                        info.information && info.information.length > 0 && info.information.map(end_info => {
                            res = JSON.stringify(info.information)
                        })
                    }
                })
                return res
            }
            case TemplateName.PREV_PAYMENT_RECEIPTS: {
                systemInfo.map(info => {
                    if (info.tagName === "BOT - LAST 3 RECEIPTS") {
                        info.information && info.information.length > 0 && info.information.map(end_info => {
                            if (end_info.tagName === "Last three receipts") {
                                res = end_info.informationDisplayValue

                            }
                        })
                    }
                })
                return res
            }
            case TemplateName.CURRENT_BILL_PLAN: {
                systemInfo.map(info => {
                    if (info.tagName === "BOT - CURRENT BILL PLAN BENEFITS") {
                        info.information && info.information.length > 0 && info.information.map(end_info => {
                            if (end_info.tagName === "Current Bill Plan Benefits") {
                                res = end_info.informationDisplayValue
                            }
                        })
                    }

                })
                return res
            }
            case TemplateName.IR_PACKS_ALL:
            case TemplateName.IR_PACKS_RECO: {
                systemInfo.map(info => {
                    if (info.tagName === "BOT - IR BOOSTERS PACKS DETAILS") {
                        info.information && info.information.length > 0 && info.information.map(end_info => {
                            if (end_info.tagName === "IR Pack Details") {
                                res = end_info.informationDisplayValue

                            }
                        })
                    }

                })
                return res
            }
            case TemplateName.IR_MULTIPLE_ZONE_PACKS:
            case TemplateName.IR_SINGLE_ZONE_PACKS:
            case TemplateName.IR_SERVICE_DEACTIVATION:
            case TemplateName.IR_ACTIVATED_PACKS_DEACTIVATION: {
                systemInfo.map(info => {
                    if (info.tagName === "BOT - IR PACKS SINGLE OR MULTIPLE ZONES") {
                        info.information && info.information.length > 0 && info.information.map(end_info => {
                            if (end_info.tagName === "Activated Packs") {
                                res = end_info.informationDisplayValue

                            }
                        })
                    }

                })
                return res
            }


        }
    }


    static handleTrackingAfterResponse = ({ enteredText, result, response }) => {

        if (ActionHandlerService.isIntentReadingFailResponse(result)) {

            TrackingMiddlewareService.setTrackingData({ user_response: enteredText, scenarioName: "", scenarioStrategy: null })
            // TRACK INTENT READING FAIL
            TrackingMiddlewareService.trackEvent(TrackingKey.INTENT_READING_FAIL)
        }
        else if (result && result.scenario &&
            (result.scenario.scenarioStrategy === ScenarioType.DTScenario ||
                result.scenario.scenarioStrategy === ScenarioType.FAQScenario ||
                result.scenario.scenarioStrategy === ScenarioType.SwitchScenario)) {
            // console.log('track intent reading success')
            let intentScore = ActionHandlerService.getIntentScore(response)
            TrackingMiddlewareService.setTrackingData({ user_response: enteredText, scenarioName: result.scenario.scenarioName, scenarioStrategy: result.scenario.scenarioStrategy, intentScore })
            // TRACK INTENT READING SUCEESS
            TrackingMiddlewareService.trackEvent(TrackingKey.INTENT_READING_SUCCESS)

        }

    }
    static getIntentScore = (response) => {

        if (response && response.executionContext && response.executionContext.scenarioMap && response.executionContext.scenario) {
            let scenarioId = response.executionContext.scenario.scenarioId
            for (let score in response.executionContext.scenarioMap) {
                if (response.executionContext.scenarioMap[score].scenarioId === scenarioId) {
                    return score;
                }
            }
        }
        return undefined
    }

    static checkIfNeedToReplaceExceptionMessage = (result, templateList) => {
        // console.log(result.response,templateList)
        if (templateList && templateList.length > 0) {
            if (templateList.includes(TemplateName.IR_ACTIVATED_PACKS_DEACTIVATION) && result && result.response && result.response.toLowerCase().includes("exception")) {
                return true
            }
            else {
                return false
            }
        }
        return false
    }

    static isIntentReadingFailResponse = (result) => {
        if (result && result.scenario && GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")] &&
            (result.scenario.scenarioId === GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["NO_INTENT_FOUND_1"].scenarioId
                || result.scenario.scenarioId === GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["NO_INTENT_FOUND_2"].scenarioId)) {
            return true
        }
        else
            return false
    }

    static isProcessingExceptionCase = (result) => {
        if (result && result.dffStepResponse && result.dffStepResponse.statusCode && result.dffStepResponse.statusCode === "PROCESSING_EXCEPTION") {
            return true
        }
        else {
            return false
        }
    }

    static isResponseUnauthorized = (response) => {
        if (response && response.status && response.status === "UNAUTHORIZED") {
            return true
        }
        return false
    }

    static isDffResponseSuccess = (result) => {
        if (result &&
            !result.scenarioActive &&
            result.dffStepResponse &&
            result.dffStepResponse.status &&
            result.dffStepResponse.status.statusCode &&
            result.dffStepResponse.status.statusCode === "success") {
            return true
        }
        return false
    }

    static isLoginRequired = (result) => {
        if (result && result.scenario && result.scenario.msisdnRequired) {
            return true
        }
        else if (result.askForLogin) {
            return true
        }
        else {
            return false
        }
    }

    static isShowDffFormCase = (result) => {
        if (result && result.dffStepResponse && result.dffStepResponse.result && result.dffStepResponse.result.length > 0) {
            return true
        }
        return false
    }

    static isCrmConsumeSrApiError = (result) => {
        if (result &&
            result.dffStepResponse &&
            result.dffStepResponse.statusCode &&
            result.dffStepResponse.statusCode ===
            "CRM_CONSUME_SR_API_ERROR"
        ) {
            return true
        }
        return false
    }

    static showLoginForm = (result, resolve) => {
        // console.log('show login form')
        let chatItem = {}
        let message_objects = []
        chatItem.response = globalConstants.login_message
        if (GlobalStoreService.get('loginSessionExpired')) {
            chatItem.response = globalConstants.login_again_message
            GlobalStoreService.set('loginSessionExpired', false)
        }
        result['initiate_after_login'] = true

        chatItem.sentTime = UtilService.getCurrentTime()

        message_objects.push({
            component_type: 'DEFAULT',
            message: chatItem.response,
            messageTime: chatItem.sentTime
        })

        resolve({ message_objects, scenarioResponse: result, bottom_comp: { type: globalConstants.BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT } })

    }


    static getTemplateResponseObject = (res) => {

        let json_start_index = res.indexOf('[json]')

        let part_str = res.substr(json_start_index + 6)

        let json_end_index = json_start_index + 6 + part_str.indexOf('[json]') + 6

        let chat_res_string = res.substr(0, json_start_index) + res.substr(json_end_index)

        let template_res_string = part_str.substr(0, part_str.indexOf('[json]'))
        return { chat_res_string, template_res_string }
    }

    static getDynamicDescriptionString = (result) => {
        let res = result.response
        let json_start_index = res.indexOf('[DYN-DESC]')

        let part_str = res.substr(json_start_index + 10)

        let dynamicDescString = part_str.substr(0, part_str.indexOf('[DYN-DESC]'))

        let templateSpecificDynamicDesc = ActionHandlerService.getTemplateSpecificDynamicDescription(result, dynamicDescString)

        let final_res = templateSpecificDynamicDesc !== `` ? res.replace(dynamicDescString, ActionHandlerService.getTemplateSpecificDynamicDescription(result, dynamicDescString)).replace(/\[DYN-DESC\]/g, '') : SCRIPTS.NO_SYSTEM_INFO_MESSAGE

        return final_res
    }

    static getTemplateSpecificDynamicDescription = (result, dynamicDescString) => {
        // console.log(result.templateNameList)
        if (result && result.templateNameList && result.templateNameList.length > 0 && result.systemInfo && result.systemInfo.length > 0) {
            switch (true) {
                case (result.templateNameList.includes('ACCOUNT_BALANCE_ACCUMULATOR') || result.templateNameList.includes('ACCOUNT_BALANCE_DETAILS')): {
                    let main_account_balance, data_validity, daily_data, remaining_data, outgoing_validity, data_4g, data_3g
                    result.systemInfo.map(info => {
                        if (info.tagName === "Comptel In Main/DA Balance") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {
                                if (end_info.tagName === "Main Account") {
                                    main_account_balance = end_info.informationDisplayValue

                                }
                                if (end_info.tagName === "DATA BALANCE 3G 1") {
                                    data_3g = end_info.informationDisplayValue

                                }
                                if (end_info.tagName === "DATA BALANCE 4G 1") {
                                    data_4g = end_info.informationDisplayValue

                                }
                            })
                        }
                        if (info.tagName === "COMPTEL - ACCUMULATOR DAILY DATA") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {
                                if (end_info.tagName === "Accumulator 1 (Daily Limit)") {
                                    daily_data = end_info.informationDisplayValue
                                }
                                if (end_info.tagName === "Accumulator 1 (Validity)") {
                                    data_validity = end_info.informationDisplayValue
                                }
                                if (end_info.tagName === "Accumulator 1 (Remaining Data)") {
                                    remaining_data = end_info.informationDisplayValue
                                }
                            })
                        }
                        if (info.tagName === "COMPTEL - OUTGOING BARRED") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {
                                if (end_info.tagName === "Outgoing validity date") {
                                    outgoing_validity = end_info.informationDisplayValue
                                }
                            })
                        }

                    })
                    let message = ``
                    if (result.templateNameList.includes('ACCOUNT_BALANCE_ACCUMULATOR')) {
                        message = `Unlimited Local & STD calls
                            <div>${daily_data} daily data</div>
                            <div>You're left with ${remaining_data}</div>
                            ${(data_validity) ? `<div>This bundle is valid till :  ${data_validity}</div>` : ``}</br>
                            <div>You've a main account balance : ${main_account_balance} & outgoing call validity is till : ${outgoing_validity}</div>
                            ${(data_4g) ? `In addition to daily data you have an additional 4G balance of ${data_4g}` : ``}`
                    }
                    else if (result.templateNameList.includes('ACCOUNT_BALANCE_DETAILS')) {
                        message = `Main account balance is Rs.${main_account_balance}
                        <div>Outgoing call validity is till ${outgoing_validity}</div>
                        ${(data_4g) ? `<div>4G data balance: ${data_4g}</div>` : ``}
                        ${(data_3g) ? `<div>3G data balance: ${data_3g}</div>` : ``}`
                    }

                    return message
                }
                case result.templateNameList.includes('LOAN_ELIGIBLE'): {
                    let loan_amount
                    result.systemInfo.map(info => {
                        if (info.tagName === "ESB - LOAN NEW") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {
                                if (end_info.tagName === "Loan Eligible_1_creditType") {
                                    loan_amount = end_info.informationDisplayValue

                                }
                            })
                        }
                    })
                    let message = `${loan_amount || `Loan-10`} Rs`

                    return message
                }
                case result.templateNameList.includes('HELLO_TUNE_DEACT'): {
                    let tune1, tune2, tune3
                    result.systemInfo.map(info => {
                        if (info.tagName === "HT STATUS NEW") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {
                                if (end_info.tagName === "HT TuneDetail Song_1_Name") {
                                    tune1 = end_info.informationDisplayValue
                                }
                                if (end_info.tagName === "HT TuneDetail Song_2_Name") {
                                    tune2 = end_info.informationDisplayValue
                                }
                                if (end_info.tagName === "HT TuneDetail Song_3_Name") {
                                    tune2 = end_info.informationDisplayValue
                                }
                            })
                        }
                    })
                    let message = tune1 || tune2 || tune3 ? `${tune1 ? `"${tune1}"` : ``} ${tune2 ? `, "${tune2}"` : ``} ${tune3 ? `, "${tune3}"` : ``}` : ``

                    return message

                }
                case result.templateNameList.includes('ACTIVE_VAS'): {
                    let obj = {}
                    result.systemInfo.map(info => {
                        if (info.tagName === "SE - VAS Check New") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {
                                for (let i = 1; i <= 5; i++) {
                                    if (end_info.tagName === `Active Vas_${i}_Name` || end_info.tagName === `Active Vas_${i}_Subscription_Date`) {
                                        obj[end_info.tagName] = end_info.informationDisplayValue
                                    }
                                }
                            })
                        }
                    })
                    let arr = []
                    if (Object.keys(obj).length > 0) {
                        for (let j = 1; j <= 5; j++) {
                            if (obj && obj.hasOwnProperty(`Active Vas_${j}_Name`) && obj.hasOwnProperty(`Active Vas_${j}_Subscription_Date`)) {
                                arr.push(`${obj[`Active Vas_${j}_Name`]} , subscribed on ${obj[`Active Vas_${j}_Subscription_Date`]}`)
                            }
                        }
                    }

                    let message = ''
                    arr.map((offer, index) => {
                        message = message + `${index + 1}. ${offer}` + `</br>`
                    })
                    return message
                }
                case result.templateNameList.includes('LAST_FEW_RECHARGES'): {
                    let obj = {}
                    result.systemInfo.map(info => {
                        if (info.tagName === "DARTS - RECHARGE DETAILS") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {

                                for (let i = 1; i <= 5; i++) {
                                    if (end_info.tagName === `Recharge Amount ${i}` || end_info.tagName === `Recharge Date ${i}`) {
                                        obj[end_info.tagName] = end_info.informationDisplayValue
                                    }
                                }
                            })
                        }
                    })
                    let arr = []
                    if (Object.keys(obj).length > 0) {
                        for (let j = 1; j <= 5; j++) {
                            if (obj && obj.hasOwnProperty(`Recharge Amount ${j}`) && obj.hasOwnProperty(`Recharge Date ${j}`)) {
                                arr.push(`Rs. ${obj[`Recharge Amount ${j}`]} , done on ${obj[`Recharge Date ${j}`]}`)
                            }
                        }
                    }
                    let message = ''
                    arr.map((offer, index) => {
                        message = message + `${index + 1}. ${offer}` + `</br>`
                    })
                    return message
                }
                case result.templateNameList.includes('MAMO_COMBO_OFFERS'): {

                    let arr = []
                    result.systemInfo.map(info => {
                        if (info.tagName === "MAMO - OFFERS COMBO NEW") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {

                                for (let i = 1; i <= 4; i++) {
                                    if (end_info.tagName === `COMBO Offer_${i}_Description`) {
                                        arr.push(end_info.informationDisplayValue)
                                    }
                                }
                            })
                        }
                    })

                    let message = ''
                    arr.map((offer, index) => {
                        message = message + `${index + 1}. ${offer} ` + `</br > `
                    })
                    return message

                }
                case result.templateNameList.includes('MAMO_VOICE_OFFERS'): {
                    let arr = []
                    result.systemInfo.map(info => {
                        if (info.tagName === "MAMO - OFFERS TALKTIME NEW") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {
                                for (let i = 1; i <= 3; i++) {
                                    if (end_info.tagName === `TALKTIME Offer_${i}_Description`) {
                                        arr.push(end_info.informationDisplayValue)
                                    }
                                }
                            })
                        }
                        if (info.tagName === "MAMO - OFFERS VOICE NEW") {
                            info.information && info.information.length > 0 && info.information.map(end_info => {
                                for (let i = 1; i <= 3; i++) {
                                    if (end_info.tagName === `VOICE Offer_${i}_Description`) {
                                        arr.push(end_info.informationDisplayValue)
                                    }
                                }
                            })
                        }

                    })
                    let message = ''
                    arr.map((offer, index) => {
                        message = message + `${index + 1}. ${offer} ` + `</br > `
                    })
                    return message
                }
                default: {
                    return dynamicDescString
                }
            }
        }

    }

}


// WEBPACK FOOTER //
// ./src/services/actions-handler.service.js